// @ts-nocheck
export default {
  PACKING_SLIP_SET_CARRIER: 'PACKING_SLIP/SET_CARRIER',
  PACKING_SLIP_SET_TRACKING: 'PACKING_SLIP/SET_TRACKING',
  PACKING_SLIP_SET_SHIPPING_QTY: 'PACKING_SLIP/SET_SHIPPING_QTY',
  PACKING_SLIP_RESET: 'PACKING_SLIP/RESET',
};
